import React from 'react'

import { Box, Grid, Tab, Tabs } from '@mui/material'

import { styles } from './FilterRow.styles'

export const TEST_ID = 'published-ideas-filter'

export type Props = {
	buttonOnClick: () => void
	disabled: boolean
	onTabChange?: (tabIndex: number, tabLabel: string) => void
}

export default function FilterRow({
	onTabChange,
}: {
	onTabChange?: Props['onTabChange']
}) {
	const [selectedTab, setSelectedTab] = React.useState(0)

	const tabLabels = [
		'ALL GAMES',
		'GAMES I CREATED',
		"GAMES I'M INVITED TO",
		'EXPIRED GAMES',
	]

	const handleTabChange = (
		_event: React.SyntheticEvent,
		newValue: number
	) => {
		setSelectedTab(newValue)
		if (onTabChange) {
			onTabChange(newValue, tabLabels[newValue])
		}
	}

	return (
		<Grid>
			<Box sx={styles.tabsContainer}>
				<Tabs
					value={selectedTab}
					onChange={handleTabChange}
					sx={styles.tabs}
					data-testid={`${TEST_ID}-tabs`}
					variant="scrollable"
					scrollButtons="auto"
				>
					<Tab
						label={tabLabels[0]}
						sx={styles.tab}
						data-testid={`${TEST_ID}-all-games-tab`}
					/>
					<Tab
						label={tabLabels[1]}
						sx={styles.tab}
						data-testid={`${TEST_ID}-created-games-tab`}
					/>
					<Tab
						label={tabLabels[2]}
						sx={styles.tab}
						data-testid={`${TEST_ID}-invited-games-tab`}
					/>
					<Tab
						label={tabLabels[3]}
						sx={styles.tab}
						data-testid={`${TEST_ID}-expired-games-tab`}
					/>
				</Tabs>
			</Box>
		</Grid>
	)
}
